var dataCast = {
    "Navigation": {
      "title": "Centre Mèdic Llucmajor",
      "queOfrecemos": 'Què Oferim',
      "quienesSomos": 'Qui Som',
      "dondeEstamos": 'On estem',
      "contacto": 'Contacte'
    },
    "Header": {
  
        "title": "Centre Mèdic Llucmajor",
        "paragraph": ["Tanquem:","1 d'Agost - 29 de Agost","Dilluns - Divendres","10:00 -13:00 i 17:00 -20:00","Dissabte: 10:00 - 13:00"]
  
    },
    "About": {
        "title":"Sobre Nosaltres",
        "paragraph": "El Centre Mèdic Llucmajor, amb més de 30 anys d'experiència en el sector, \
          tenim la millor equipació de revisions mèdiques del\
          mercat amb un equip de professionals perfectament qualificats en les \
          àrees de psicologia, oftalmologia i medicina general. \
          Situat al costat de la parada de metro de Llucmajor, és la millor opció per renovar el seu \
          carnet de conduir, la seva llicència d'armes, seguretat privada, estrangeria, marina, \
          animals perillosos, grua i més. Oferim un servei ràpid i excel·lent per \
          obtenir els certificats mèdics corresponents.",
        "whyTitle":"¿Per què Nosaltres?",
        "Why": [
            "Rapidesa",
            "Comoditat",
        ],
        "Why2": [
            "Varietat de serveis",
            "Experiència"
        ]
    },
    "Cupon": {
      "title":"ACONSEGUEIX UN CUPÓ  DE DESCOMPTE!",
      "click":"Feu click a la imatge!"
    },
    "Services": {
      "title": "Què Oferim",
      "subtitle":"Per renovar el carnet de conduir del tipus A / B / C / D / E o BTP només \
                  li farà falta portar el DNI i el seu carnet de conduir (en cas \
                  de renovació). El nostre centre mèdic s’encarregarà de la resta.",
      "services": [
          {
            "icon": "fa fa-car",
            "name": "Carnet de conduir",
            "text": ["Renovació del carnet de conduir.","Nous conductors: AM, A1, A, B."]
          },
          {
            "icon": "fa fa-stethoscope",
            "name": "Psicotècnics",
            "text": ["Certificats psicotècnics per llicències d’armes, \
            llicències d'embarcació, animals potencialment perillosos, \
            seguretat privada, vigilant, grúa, submarinisme, pesca...en aquest apartat tobareu\
            tota la informació dels psicotècnics."]
          },
          {
            "icon": "fa fa-heartbeat",
            "name": "Certificats Mèdics",
            "text": ["Certificats mèdics per a tots els tràmits: esportius, escolars, \
            laborals, per adopcions, oposicions, generals, per a taxi, agents de duana... \
            en aquesta secció es descriu tote la informació relativa als certificats mèdics."]
          },
          {
            "icon": "fa fa-flash",
            "name": "Fàcil",
            "text": ["Sense cita prèvia. Sense fotografies. Només porti el seu DNI i el seu carnet de conduir \
            i nosaltres ens encarreguem de la resta."]
          },
          {
            "icon": "fa fa-coffee",
            "name": "Despreocupis",
            "text": ["Nosaltres mateixos tramitem la seva renovació del carnet de conduir (prèvi \
              pagament de les taxes). Rebeu-lo directament al domicili, sense cues ni esperes \
              (enviament realizat per la DGT)."]
          },
          {
            "icon": "fa fa-clock-o",
            "name": "Ampli horari",
            "text": ["De Dilluns a Divendres de 10:00 a 13:00 i de 17:00 a 20:00","Dissabte de 10:00 a 13:00","Al costat de la parada de metro "]
          }
      ]
    },
    "Contact": {
        "title":"Contacte amb nosaltres",
        "subTitle":"Si us plau, ompli el següent formulari per contactar amb \
                    nosaltres via email i li contestarem el més aviat possible.",
        "formData": {
            "name":"Nom",
            "email":"Correu",
            "message":"Missatge",
            "sendButton":"Envia correu",
            "success":"Gràcies!",
            "error":"Ooops! Hi ha hagut un error.",
            "consent": "Accepto la política de privacitat y dono consentiment pel tractament de dades",
            "consentPrivacy": "Política de privacitat",
            "consentData": "Consentiment pel tractament de dades"
        },

        "contact": "Contacte",
        "addressLabel": "Adreça",
        "address": ["Pª Valldaura 218 - 220 2º4","Pª Verdum, 55-57  2º4ª","08042 Llucmajor, Barcelona"],
        "phoneLabel": "Telèfon",
        "phone": "+34 933537630",
        "emailLabel": "Correu",
        "email": "cmllucmajor@cmllucmajor.com",

        "facebook": "fb.com",
        "twitter": "twitter.com",
        "youtube": "youtube.com",
    },
    "Map": {
      "metro": " Estacions de metro: Llucmajor (Línia 4)",
      "buses": "Autobuses: H4, H2, D40, D50, 47, V29, 76"
    },
    "Team":{
      "temporalDays": "TANQUEM",
      "temporalHours": "1 d'Agost - 29 de Agost",
      "firstDays": "DILLUNS A DIVENDRES",
      "firstHours": "10:00 - 13:00 y 17:00 - 20:00",
      "secondtDays": "DISSABTE",
      "secondtHours": "10:00-13:00"
    },
    "Gallery": {
      "title":"PERMISOS",
      "intro": "Proporcionem certificats mèdics per Possessió d'armes\
              Seguretat privada / Vigilants de seguretat,\
              Tinença d'animals perillossos,\
              P.E.R,\
              Residència,\
              Traball,\
              Oposicions,\
              Conducció de grues,\
              Homologació de permissos estrangers,\
              Esports nivell 1, i \
              Pèrdua de punts. ",
      "images": [
        {
            "text": "Cotxe",
            // "image": "img/portfolio/01-small.jpg",
            "image": "img/gallery/coche.png",
        },
        {
            "text": "Moto",
            // "image": "img/portfolio/01-small.jpg",
            "image": "img/gallery/moto.png",
        },
        {
            "text": "Camions pesants",
            // "image": "img/portfolio/01-small.jpg",
            "image": "img/gallery/camion.png",
        },
          {
              "text": "Possessió d'armes",
              // "image": "img/portfolio/01-small.jpg",
              "image": "img/gallery/armas.png",
          },
          {
              "text": "Seguretat privada / vigilants de seguretat",
              "image": "img/gallery/seguridad.png",
          },
          {
              "text": "Tinença d'animales perillosos",
              "image": "img/gallery/perro.png",
          },
          {
              "text": "P.E.R",
              "image": "img/gallery/per.png",
          },
          {
              "text": "Treball",
              "image": "img/gallery/working.png",
          },
          {
              "text": "Conducció de grues",
              "image": "img/gallery/grua.png",
          },
          {
              "text": "Homologació de permisos estrangers",
              "image": "img/gallery/imigrantes.png",
          },
          {
              "text": "Residència",
              "image": "img/gallery/residencia.png",
          },
          {
              "text": "Oposicions",
              "image": "img/gallery/oposiciones.png",
          },
      ]
    },
    
    "Cookies": {
      "btnAccept": "Acceptar",
      "btnConfig": "Panell Cookies",
      "main": "Utilitzem cookies pròpies i de tercers per a fins analítics i \
              per a mostrar publicitat personalitzada en base a un perfil elaborat \
              a partir dels seus hàbits de navegació (per exemple, pàgines visitades).\
              Per a mès informació consulti el",
      "link": "política de cookies",
      "configure": 'Pot acceptar totes les cookies prement el botó "Acceptar" o configurar-les \
                    o rebutjar-ne seu ús prement el botó "Configurar"',
    }
  }
  export default dataCast